import { IAppState } from "models";
import { initState } from "models/mdt";


export const initialState = (): IAppState => {
	return {
		page: {
			dashboard: initState(),
			loading: true,
			computing: false,
		},
		userSettings: {
			isAdmin: false,
			qoolLink: null,
			qlikLink: null,
		},
		appSettings: {
			showInternalLinks: false
		}
	}
}
